import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Menu,
  MenuItem,
  Modal,
  Divider
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisualFileUploadModal from './VisualFileUploadModal';
import { getVisualFilesByProjectIdAndTopicId, deleteVisualFile, deleteVisualNoteWithFiles } from '../../apis/apiList/projectApi';
import { useMessage } from '../../context/MessageContext';
import BeatLoader from "react-spinners/BeatLoader";
import theme from "../../theme/theme";

const VisualPreviewModal = ({ open, onClose, projectId, topicDetail, userDetails }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [visualData, setVisualData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [selectedVisualfileDetail, setSelectedVisualfileDetail] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeletingNote, setIsDeletingNote] = useState(false);

  const { showMessage } = useMessage();


  useEffect(() => {
    async function fetchVisualFiles() {
      setLoading(true);
      console.log('running preview functiont for', projectId, topicDetail);
      try {
        let ids = {
          projectId: projectId,
          topicId: topicDetail._id
        }
        const response = await getVisualFilesByProjectIdAndTopicId(ids, {
          headers: {
            "x-access-token": userDetails.jwtToken
          }
        })
        console.log('response', response);
        setVisualData(response.visualFiles)
        // setVisualData(visuals)
        setLoading(false);
      } catch (error) {
        console.error('Error fetching visual files:', error);
        setLoading(false);
      }
    }
    if (open) fetchVisualFiles();
  }, [open]);

  const handleMenuClick = (event, sectionIndex, visual) => {
    event.stopPropagation();
    console.log('sectionIndex', sectionIndex);
    console.log('visualId', visual);
    setSelectedVisualfileDetail(visual);
    setMenuAnchor(event.currentTarget);
    setSelectedSection(sectionIndex);
  };

  const handleDownload = async (file) => {
    const a = document.createElement('a');
    a.href = file.fileUrl;
    a.download = file.fileOriginalName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleFileDeleteConfirm = async () => {
    console.log('fileToDelete', fileToDelete);
    setIsDeleting(true);
    try {
      const response = await deleteVisualFile(fileToDelete?.visual?._id, fileToDelete?.file?.fileId, {
        headers: {
          "x-access-token": userDetails.jwtToken
        }
      });
      console.log('File deleted successfully:', response);

      const visualId = fileToDelete?.visual?._id;
      const remainingFiles = response.remainingFiles;

      setVisualData(prev => {
        return prev.map(visual => {
          if (visual._id === visualId) {
            const enrichedFiles = remainingFiles.map(file => {
              const existingFile = visual.files.find(f => f.fileId === file.fileId);
              return {
                ...file,
                ...(existingFile || {})
              };
            });

            return {
              ...visual,
              files: enrichedFiles
            };
          }
          return visual;
        });
      });

      setFileToDelete(null);
      // const updated = [...visualData];
      // updated[fileToDelete.sectionIndex].files = updated[fileToDelete.sectionIndex].files.filter(
      //   (_, index) => index !== fileToDelete.fileIndex
      // );
      // setVisualData(updated);
      setIsDeleting(false);
      showMessage('File deleted successfully', 'success');
    } catch (error) {
      console.error('Error deleting file:', error);
      showMessage('Failed to delete file', 'error');
      setIsDeleting(false);
    }
  };
  
  const handleVisualNoteDeleteConfirm = async () => {
    console.log('fileToDelete', fileToDelete);
    setIsDeletingNote(true);
    try {
      const response = await deleteVisualNoteWithFiles(selectedVisualfileDetail._id, {
        headers: {
          "x-access-token": userDetails.jwtToken
        }
      });
      console.log('Visual note deleted successfully:', response);

      setVisualData(prev => prev.filter(visual => visual._id != selectedVisualfileDetail._id));
      
      setIsDeletingNote(false);
      setShowDeleteConfirm(false);
      showMessage('Visual note deleted successfully', 'success');
    } catch (error) {
      console.error('Error deleting file:', error);
      showMessage('Failed to delete file', 'error');
      setIsDeletingNote(false);
      setShowDeleteConfirm(false);
    }
  };

  const isImage = (filename) => /\.(jpe?g|png|gif|bmp|tiff|webp)$/i.test(filename);
  const isVideo = (filename) => /\.(mp4|webm|mov|avi|flv|wmv)$/i.test(filename);

  const handleSave = (editedVisual) =>{
    setEditModalOpen(false);
    console.log('editedVisual', editedVisual);
    const updateVisualData = (editedVisual) => {
      const updated = [...visualData];
      const index = updated.findIndex((visual) => visual._id == editedVisual._id);
      if (index > -1) {
        updated[index] = editedVisual;
      }
      setVisualData(updated);
    };
    updateVisualData(editedVisual);
  }

  const override = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    left: "50%",
  };
  return (
    <>
      <Dialog open={open} onClose={onClose} fullScreen>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ccc', fontSize: '20px' }}>
          Uploaded Visuals for {topicDetail.title}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3, mt: 2 }}>
          {loading ? (
            <Box sx={override}>
              <BeatLoader
                color={theme.palette.primary.main}
                loading={loading}
                size={25}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </Box>
          ) : (
            <>
              {
                visualData?.length == 0 ? (
                  <Typography variant="body1">No visuals uploaded for this topic yet.</Typography>
                )
                :
                  visualData.map((visual, visualIndex) => (
                    <Card key={visualIndex} sx={{ mb: 4, p: 2, border: '1px solid gainsboro', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center" pb='10px'>
                        <Typography variant="subtitle1">
                          <strong>Note:</strong> {visual.note}
                        </Typography>
                        <IconButton onClick={(e) => handleMenuClick(e, visualIndex, visual)}>
                          <MoreVertIcon />
                        </IconButton>
                      </Box>
                      <Grid container spacing={2}>
                        {visual.files.map((file, fileIndex) => (
                          <Grid item xs={12} sm={6} md={4} lg={2} key={fileIndex}>
                            <Card sx={{ border: '1px solid gainsboro', borderRadius: '10px' }}>
                              {isImage(file.fileOriginalName) ? (
                                <CardMedia component="img" image={file.fileUrl} sx={{ height: 200 }} />
                              ) : isVideo(file.fileOriginalName) ? (
                                <CardMedia component="video" src={file.fileUrl} controls sx={{ height: 200 }} />
                              ) : null}

                              <CardContent>
                                <Typography variant="body2" noWrap>
                                  {file.fileOriginalName}
                                </Typography>
                              </CardContent>

                              <CardActions sx={{ justifyContent: 'space-between' }}>
                                <Button onClick={() => handleDownload(file)} size="small">
                                  <DownloadIcon />
                                </Button>
                                <IconButton
                                  onClick={() => setFileToDelete({ visual, file, visualIndex, fileIndex })}
                                  size="small"
                                  color="error"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </Card>
                  ))
              }
            </>
          )}
        </DialogContent>
      </Dialog>

      <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        <MenuItem
          onClick={() => {
            setEditModalOpen(true);
            setMenuAnchor(null);
          }}
        >
          <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit Visual Note
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowDeleteConfirm(true);
            setMenuAnchor(null);
          }}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} /> Delete Visual Note
        </MenuItem>
      </Menu>

      {/* Visual note delete confirmation modal */}
      <Modal open={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24 }}>
          <Box sx={{  p: '20px 20px 0px 20px'}}>
            <Typography variant="h3">Delete visual note</Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography sx={{  p: '0px 20px 0px 20px'}} variant="h5">Are you sure you want to delete this visual note?</Typography>
          <Box sx={{ p: '10px 20px 20px 20px'}} mt={2} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={() => setShowDeleteConfirm(false)}>Cancel</Button>
            <Button color="error" variant="contained" disabled={isDeletingNote} onClick={() => {
              // const updated = visualData.filter((_, idx) => idx !== selectedSection);
              // setVisualData(updated);
              // setShowDeleteConfirm(false);
              handleVisualNoteDeleteConfirm();
            }}>
              {isDeletingNote ? 'Deleting...' : 'Delete'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* File delete confirmation modal */}
      <Modal open={!!fileToDelete} onClose={() => setFileToDelete(null)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24 }}>
          <Box sx={{  p: '20px 20px 0px 20px'}}>
            <Typography variant="h3">Delete file</Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography sx={{  p: '0px 20px 0px 20px'}} variant="h5">Are you sure you want to delete this file?</Typography>
          <Box sx={{ p: '10px 20px 20px 20px'}}  mt={2} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={() => setFileToDelete(null)}>Cancel</Button>
            <Button color="error" variant="contained" onClick={handleFileDeleteConfirm} disabled={isDeleting}>
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {editModalOpen && (
        <VisualFileUploadModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          userDetails={userDetails}
          projectId={projectId}
          onSave={handleSave}
          topicDetail={topicDetail}
          actionType={'edit'}
          section={visualData[selectedSection]}
          sectionIndex={selectedSection}
          visualDetails={selectedVisualfileDetail}
        />
      )}
    </>
  );
};

export default VisualPreviewModal;
